module.exports = __webpack_public_path__ + "static/img/jssm_icon.png";